import axios from 'axios';
import config from '../../config';
import { showError } from '../utils';
import { baseRequestWithHeaders } from './api/base-request';
import { setAuthToken } from '../actions';
import { store } from '../store';

const redirectForLogin = () => {
  window.location.href = '/';
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const statusCode = error.response ? error.response.data.code : null;
    if (statusCode === 401) {
      store.dispatch(setAuthToken(''));
      return redirectForLogin();
    }

    return Promise.reject(error);
  }
);

export function loginUser(username, password) {
  const body = {
    username,
    password,
  };
  return axios
    .post(`${config.apiBaseUrl}/network/login`, body)
    .then((res) => {
      const responseBody = res.data;
      const responseHeaders = res.headers;
      if (responseBody.message === 'loggedIn') {
        return {
          body: responseBody,
          headers: responseHeaders,
        };
      }
      const err = new Error('Invalid response');
      err.data = responseBody;
      throw err;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function userInfo(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/new-auth/login-info?v=123`, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      const responseCode = resp.status;
      if (responseCode === 200) {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    });
}

export const sendGoogleLogin = (token) => {
  const url = 'oauth/login';
  const method = 'POST';
  const data = {
    token,
  };
  return baseRequestWithHeaders(url, method, null, data);
};
